/**
 * Unified analytics event tracker.
 * Pushes the same event to GTM dataLayer, GA4 (gtag), Meta Pixel, and Baidu Tongji.
 * Safe to call even if no analytics IDs are configured — silently no-ops.
 *
 * Usage:
 *   trackEvent("booking_intent", { channel: "whatsapp", source: "hero" })
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;

  // Standard payload
  const payload = {
    event: name,
    ...params,
    page_location: window.location.href,
    page_title: document.title,
  };

  try {
    // 1) GTM dataLayer (will fan out to anything configured inside GTM)
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }

    // 2) GA4 direct (if gtag is loaded outside GTM)
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }

    // 3) Meta Pixel — map to standard or custom event
    if (typeof window.fbq === "function") {
      const metaStandardMap = {
        booking_intent: "Lead",
        whatsapp_click: "Contact",
        wechat_click: "Contact",
        phone_click: "Contact",
        view_pricing: "ViewContent",
        promo_claim: "InitiateCheckout",
      };
      const metaName = metaStandardMap[name];
      if (metaName) {
        window.fbq("track", metaName, params);
      } else {
        window.fbq("trackCustom", name, params);
      }
    }

    // 4) Baidu Tongji — _hmt.push(['_trackEvent', category, action, label])
    if (Array.isArray(window._hmt)) {
      window._hmt.push([
        "_trackEvent",
        params.category || "engagement",
        name,
        params.label || params.channel || params.source || "",
      ]);
    }
  } catch (e) {
    // Never let analytics break UX
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("trackEvent failed", e);
    }
  }
}
